document.addEventListener('DOMContentLoaded', function() {

	if ( $( ".navbar" ).is( ".sticky-header" ) ) {

		var header = document.getElementById("site-header");
		var navbar = document.getElementById("navbar")
		var sticky = navbar.offsetTop;

        var disclaimerHeight = $(".site-disclaimer:visible");

		// Calculate height of sticky header
		var headerHeight = +disclaimerHeight.outerHeight() + +$('#navbar').outerHeight();

        window.addEventListener('scroll', stickyHeader);

        function stickyHeader() {

            var ALDHeader = document.querySelector('nav');

            if (ALDHeader.classList.contains('ald-header')) {

                if (window.pageYOffset > 50) {
                    header.classList.add("fixed-top");
                    $('#content').css('padding-top', headerHeight + 'px');
                } else {
                    header.classList.remove("fixed-top");
                    $('#content').removeClass().removeAttr('style');
                }

            } else {
                if (window.pageYOffset > sticky) {
                    header.classList.add("fixed-top");
                    $('#content').css('padding-top', headerHeight + 'px');
                } else {
                    header.classList.remove("fixed-top");
                    $('#content').removeClass().removeAttr('style');
                }
            }
		}
    }

    // nav bar accessibility
    $(".nav-link.dropdown-toggle").focus(function () {
        $(".dropdown-menu").removeClass("dropped")
        $(this).next(".dropdown-menu").addClass("dropped")
    });

    $(".nav-link.dropdown-toggle").mouseover(function () {
        $(".dropdown-menu").removeClass("dropped")
    });

    $(".dropdown-menu.sub-menu").each(function () {
        var dropdown = $(this);
        $(this).find("li:last > a").focusout(function () {
            dropdown.removeClass("dropped")
        });
    });

    $(".branding a").focus(function () {
        $(".dropdown-menu").removeClass("dropped");
    })

    // custom dropdown accessibility
    //$("#custom-dropdown-label").focus(function () {
    //    $(this).next(".custom-dropdown-list").addClass("dropped")
    //});

    //$("#custom-dropdown-label").mouseover(function () {
    //    $(".custom-dropdown-list").removeClass("dropped")
    //});

    //custom dropdown bug fix
    $("#custom-dropdown-label").on('click', function () {
        $(this).next(".custom-dropdown-list").toggleClass("dropped")
    });

    $(".custom-dropdown-list").find("li:last > a").focusout(function () {
        $(".custom-dropdown-list").removeClass("dropped")
    });

    $("#skip-link").focus(function () {
        $(".custom-dropdown-list").removeClass("dropped");
    })

    //Sticky nav hidden text

    $(document).ready(function () {
        if ($('.page-navigation').length >0) {
            var pageNav = $('.page-navigation').offset();
            var $window = $(window);
            $window.scroll(function () {
                //console.log(pageNav);
                if ($window.scrollTop() >= pageNav.top) {
                    $(".page-navigation").addClass("is-pinned");
                } else {
                    $(".page-navigation").removeClass("is-pinned");
                }
            });
        }
    });

    //Mobile nav left and right arrows on scroll
    $(document).ready(function () {
        var active = $('.primary-menu .level-1-link.active')[0];
        if (active) {
            active.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
            // open the active submenu
            $(active).next().addClass('sub-menu-open');
        }
        // On page load show right arrow
        $('.primary-menu-right').addClass('show');

        // On horizontal scroll 
        $(".primary-menu").on("scroll", function () {
            // Horizontal scroll left
            var cur = $(this).scrollLeft();
            console.log(cur);

            // If not scrolled left, keep right arrow
            if (cur <= 40) {
                $('.primary-menu-right').addClass('show');
                $('.primary-menu-left').removeClass('show');
            }
            // Else if scrolled left
            else {
                var max = $(this)[0].scrollWidth - $(this).width() - 1;
                console.log(cur);
                console.log(max);
                // If scrolled all the way to the left, show the left arrow and remove the right arrow
                if (cur >= max) {
                    $('.primary-menu-left').addClass('show');
                    $('.primary-menu-right').removeClass('show');
                    // If in the middle of scrolling left, show arrows on both right and left sides 
                } else {
                    $('.primary-menu-right').addClass('show');
                    $('.primary-menu-left').addClass('show');
                }
            }
        });
        $(".navbar-nav").trigger("scroll");
    });

    // Navbar hide on scroll down, show sticky on scroll up
    var prev = 0;
    var $window = $(window);
    var windowHeight = $(window).height();
    var nav = $('#site-header');
    $window.on('scroll', function () {
        var isZynteglo = window.location.href.indexOf("zynteglo") > -1;
        var isSkysona = window.location.href.indexOf("skysona") > -1;
        var isMybluebirdSupport = window.location.href.indexOf("mybluebirdsupport") > -1;
        var isLyfgenia = window.location.href.indexOf("lyfgenia") > -1;

        if (isZynteglo || isSkysona || isMybluebirdSupport || isLyfgenia) {
            var scrollTop = $window.scrollTop();
            var bodyHeight = $(document.body).height();

            if (scrollTop < prev) {
                // scrolling up
                // show the nav, but not if you're at the very bottom of the page (scrollTop can go past the end of
                // the page on iPhone, and then bounce back up, so the code might wrongly consider that as scrolling up)
                if ((scrollTop + windowHeight + 300) < bodyHeight) {
                    if (isSkysona || isLyfgenia || isZynteglo) {
                        nav.css({position: 'sticky'});
                    } else {
                        nav.removeClass('hidden');   // show the nav
                    }
                }
            }
            else if (scrollTop > prev) {
                // scrolling down
                // hide the nav, but not if you're at the very top of the page (scrollTop can become negative on iPhone as you're
                // scrolling up to the top of the page, and then it bounces back, which might be wrongly considered as scrolling down)
                if (scrollTop > 0) {
                    if (isSkysona || isLyfgenia || isZynteglo) {
                        nav.css({position: 'initial'});
                    } else {
                        nav.addClass('hidden');    // hide the nav
                    }
                }
            }
            prev = scrollTop;
        }
    });

    // Add active class to primary menu, expand sub pages on the mobile menu
    $(document).ready(function(){
        var currentPageUrl = window.location.pathname;
        $('.primary-menu .level-1-link').each(function(){
            var linkUrl = $(this).attr('href');
            if (linkUrl.length > 1 && currentPageUrl.includes(linkUrl) === true) {
                $(this).addClass('active');
                $(this).next().addClass('sub-menu-open');
            }
        });
    });
});